import React from "react";
import {TableCell} from '@aws-amplify/ui-react';

function PixelFormatCell(props) {
  return (
      <>
        <TableCell className="synamedia-td">
          {
            props.distorted ?
                props.distorted.spec_pix_fmt
                :
                ''
          }
        </TableCell>
      </>
  );
}

export default PixelFormatCell;
